import axios from '../../v2/app/services/axiosService';
import store from '../../vuex/store';
import * as types from '../../vuex/mutation-types';
import _ from 'lodash';

export default {
  getConsentModes() { // MLD-780
    return [
      {id: 'not_required', name: 'No consent required', description: 'The prospect will not be prompted to accept the privacy policy. Consent is implied.'},
      //{id: 'optional', name: 'Optional consent', description: 'The prospect will be prompted to accept the privacy policy, but can opt-out and still view the content.'},
      {id: 'required', name: 'Consent required', description: 'The prospect will be required to accept the privacy policy before viewing the content.'},
    ]
  },
  getNotificationLevels() {
    return [
      {id: 0, name: 'None'},
      {id: 1, name: 'On first click'},
      {id: 2, name: 'On every click'},
      {id: 3, name: 'Weekly'},
      {id: 4, name: 'Monthly'},
    ]
  },
  async quickShare(form) { // MLD-4010
    const response = await form.post(`/api/presentations/quick-share`);
    return response.data;
  },
  async bulkShareSpaces(form) { // MLD-4908
    const response = await axios.post(`/api/spaces/share`, form);
    return response.data;
  },
  async bulkSharePresentations(form) {
    const response = await axios.post(`/api/presentations/share`, form);
    return response.data;
  },
  getStatuses() {
    return [
      {id: 'Active', name: 'Active'},
      {id: 'Canceled', name: 'Canceled'},
      {id: 'Expired', name: 'Expired'},
    ]
  },
  getTypes() {
    return [
      {id: 'Email', name: 'Email'},
      {id: 'Link', name: 'Link'},
      {id: 'Space', name: 'Space'}, // MLD-5236
    ]
  },
  async getHits(params = {}) {
    const response = await axios.get(`/api/shared-link-hits`, {params});
    return response.data;
  },
  async getPublicSharedLink(token) { // MLD-7991
    const response = await axios.get(`/api/public/shared-links/${token}`);
    return response.data;
  },
  async getHitByUUID(hitUUID) {
    const response = await axios.get(`/api/public/shared-link-hits/${hitUUID}`);
    return response.data;
  },
  async updateHitByUUID(hitUUID, form) {
    const response = await axios.put(`/api/public/shared-link-hits/${hitUUID}`, form);
    return response.data;
  },
  async sendNotification(hitUUID) { // MLD-1554
    const response = await axios.post(`/api/public/shared-link-hits/${hitUUID}/notify`);
    return response.data;
  },
  async getSharedLinks(params = {}) {
    const response = await axios.get(`/api/shared-links`, {params});
    return response.data;
  },
  forPresentation(presentationId) {
    return _.filter(store.state.sharedLinks, link => {
      return link.presentation_id === presentationId;
    });
  },
  async getLinkFromToken(token) {
    const response = await axios.get(`/api/public/shared-links/${token}`);
    return response.data;
  },
  async getLink(linkID) {
    const response = await axios.get(`/api/shared-links/${linkID}`);
    return response.data;
  },
  async activate(linkID) { // MLD-5627
    const response = await axios.put(`/api/shared-links/${linkID}/activate`);
    return response.data;
  },
  async deactivate(linkID) {
    const response = await axios.put(`/api/shared-links/${linkID}/deactivate`);
    return response.data;
  },
  cancel(linkID) {
    return this.deactivate(linkID);
  },
  async deleteLink(linkID) {
    const response = await axios.delete(`/api/shared-links/${linkID}`);
    return response.data;
  },
  async expire(linkID) {
    const response = await axios.put(`/api/shared-links/${linkID}/expire`);
    return response.data;
  },
  forUser(userId) {
    return _.filter(store.state.sharedLinks, link => {
      return link.user_id === userId;
    });
  },
  async sharePresentation(presentationID, form) {
    const response = await axios.post(`/api/presentations/${presentationID}/share`, form);
    return response.data;
  },
  async update(form, linkID) { // MLD-5627
    const data = this.form.fields();
    if (!data.link_expires) {
      data.expires_at = null;
    }
    const response = await form.patch(`/api/shared-links/${linkID}`, {data});
    return response.data;
  },
  async changeNotificationLevel(token, notificationLevel) { // MLD-2151
    const form = {
      notification_level: notificationLevel,
    }
    const response = await axios.put(`/api/public/mute/${token}/notifications`, form);
    return response.data;
  },
  muteNotifications(token) { // MLD-2151
    return this.changeNotificationLevel(token, 0);
  },
  async muteReminders(token) {
    const form = {
      is_muted: true,
    };
    const response = await axios.put(`/api/public/mute/${token}/reminders`, form);
    return response.data;
  },
  async unmuteLink(token) {
    const form = {
      is_muted: false,
    };
    const response = await axios.put(`/api/public/mute/${token}/reminders`, form);
    return response.data;
  },
  async forward(hitUUID, form) { // MLD-1421
    const response = await axios.post(`/api/public/shared-link-hits/${hitUUID}/forward`, form);
    return response.data;
  },
  async exportLinks(form = {}) { // MLD-1665
    const response = await axios.post(`/api/shared-links/export`, form);
    // https://stackoverflow.com/questions/43432892/force-download-get-request-using-axios
    let blob = new Blob([response.data], {type: 'text/csv'});
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `shared_links.csv`;
    link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
  },
  async exportHits(form = {}) { // MLD-1908
    const response = await axios.post(`/api/shared-link-hits/export`, form);
    // https://stackoverflow.com/questions/43432892/force-download-get-request-using-axios
    let blob = new Blob([response.data], {type: 'text/csv'});
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `shared_link_hits.csv`;
    link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
  },
  clearCache() { // MLD-1618
    return axios.delete(`/api/shared-links/cache`);
  },
  async doesAliasExist(alias, linkID) { // MLD-1859
    const options = {
      params: {
        alias: alias,
        link_id: linkID,
      }
    }
    const response = await axios.get(`/api/shared-links/check-alias`, options);
    return response.data;
  },
  async generateAlias(presentationID, alias) { // MLD-1859
    const options = {
      params: {
        alias,
      }
    }
    const response = await axios.get(`/api/presentations/${presentationID}/shared-link-alias`, options);
    return response.data;
  }
}
